import React from 'react';
import { Link } from 'react-router-dom';
import type { ConversationAttachment } from '../../types/conversation.types';
import MessageAttachments from './MessageAttachments';

interface ChatMessageProps {
  role: 'user' | 'agent' | 'system';
  content: string;
  supportRequestId?: string | null;
  attachments?: ConversationAttachment[] | null;
}

const agentStyle: React.CSSProperties = {
  padding: 'var(--space-3) var(--space-4)',
  borderLeft: '3px solid var(--primary-200)',
  fontSize: 'var(--text-sm)',
  color: 'var(--gray-800)',
  lineHeight: 'var(--leading-normal)',
  whiteSpace: 'pre-wrap',
};

const userStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'flex-end',
  padding: '0 var(--space-4)',
};

const userBubbleStyle: React.CSSProperties = {
  maxWidth: '80%',
  padding: 'var(--space-2) var(--space-3)',
  background: 'var(--primary-50)',
  borderRadius: 'var(--radius-lg)',
  fontSize: 'var(--text-sm)',
  color: 'var(--gray-900)',
  lineHeight: 'var(--leading-normal)',
  whiteSpace: 'pre-wrap',
};

const systemStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  padding: '0 var(--space-4)',
};

const systemBannerStyle: React.CSSProperties = {
  padding: 'var(--space-3) var(--space-4)',
  background: 'var(--success-50)',
  border: '1px solid var(--success-200)',
  borderRadius: 'var(--radius-lg)',
  fontSize: 'var(--text-sm)',
  color: 'var(--gray-800)',
  textAlign: 'center' as const,
};

const ChatMessage: React.FC<ChatMessageProps> = ({ role, content, supportRequestId, attachments }) => {
  const hasAttachments = attachments && attachments.length > 0;

  if (role === 'agent') {
    return (
      <div style={agentStyle}>
        {content}
        {hasAttachments && <MessageAttachments attachments={attachments} />}
      </div>
    );
  }

  if (role === 'user') {
    return (
      <div style={userStyle}>
        <div style={userBubbleStyle}>
          {content}
          {hasAttachments && <MessageAttachments attachments={attachments} />}
        </div>
      </div>
    );
  }

  // system
  return (
    <div style={systemStyle}>
      <div style={systemBannerStyle}>
        <div>{content}</div>
        {supportRequestId && (
          <Link
            to={`/support/${supportRequestId}`}
            className="d-inline-block mt-2 text-primary-600 font-medium no-underline"
          >
            Перейти к обращению →
          </Link>
        )}
      </div>
    </div>
  );
};

export default ChatMessage;
